import { render } from "./TituloProjetoAntecessor.vue?vue&type=template&id=a036287a&scoped=true"
import script from "./TituloProjetoAntecessor.vue?vue&type=script&lang=js"
export * from "./TituloProjetoAntecessor.vue?vue&type=script&lang=js"

import "./TituloProjetoAntecessor.vue?vue&type=style&index=0&id=a036287a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a036287a"]])

export default __exports__